import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "repair-type-block" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "报修类型", -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tag tag1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "支持质保/意外险极加/升级保养等全部服务权益，实际维慘权益以定责结果为准！", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tag tag2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createTextVNode("快捷提单选项，仅支持"),
  /*#__PURE__*/_createElementVNode("span", { class: "import-tip" }, "付费维修或升级保养"),
  /*#__PURE__*/_createTextVNode("等业务。 ")
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import { ref} from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'repair-type-block',
  props: {
    isCanSelect: { type: Boolean, default: true }
  },
  emits: ['change'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { isCanSelect: boolean };



expose({
  setIsRepair(index: number){
    console.log('setIsRepair',index)
    isRepair.value = index
  }
})




let isRepair = ref(0)

function changeRepairHandle(index: number) {
  isRepair.value = index
  emits('change', index)
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["content-item", {'active': _unref(isRepair) === 0}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (props.isCanSelect && changeRepairHandle(0)))
      }, _hoisted_6, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["content-item", {'active': _unref(isRepair) === 1}]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (props.isCanSelect && changeRepairHandle(1)))
      }, _hoisted_9, 2)
    ])
  ]))
}
}

})